import type { AppNote } from '../../../shared/domain/notes/types.no-deps'

type Note_Status = 'synced' | 'pendingUpload'

export interface Note_Note extends AppNote {
    status: Note_Status
}

export function Note_toNote(syncNote: AppNote, status: Note_Status): Note_Note {
    return {
        id: syncNote.id,
        title: syncNote.title,
        content: syncNote.content,
        createdAt: syncNote.createdAt,
        lastModified: syncNote.lastModified,
        status,
    }
}
